"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _date = require("@ha/date");

var _constants = require("../constants");

var isShortRangeRent = function isShortRangeRent(startDate, endDate) {
  return Boolean(startDate && endDate && (0, _date.diffDay)(endDate, startDate) <= _constants.ShortRangeRentThreshold);
};

var getCurrentDateUtc = function getCurrentDateUtc() {
  return new Date().toUTCString();
};

var normalizeStartDate = function normalizeStartDate() {
  var startDateLimit = new Date();
  startDateLimit.setMonth(startDateLimit.getMonth() + _constants.NoStartDateMonthLimit);
  startDateLimit.setDate(0);
  startDateLimit.setHours(0, 0, 0);
  return startDateLimit.toDateString();
};

var gapMinimizeFilter = function gapMinimizeFilter(startDate, endDate) {
  if (!startDate) {
    return '';
  }

  var minStartDateLimit = new Date(startDate);
  minStartDateLimit.setDate(1);
  var hasBothDatesAndIsShort = isShortRangeRent(startDate, endDate);
  var hasOnlyMoveInDateAndIsShort = !endDate && isShortRangeRent(getCurrentDateUtc(), startDate);

  if (hasBothDatesAndIsShort || hasOnlyMoveInDateAndIsShort) {
    minStartDateLimit.setMonth(minStartDateLimit.getMonth() - 1);
    minStartDateLimit.setDate(0);
  } else {
    minStartDateLimit.setMonth(minStartDateLimit.getMonth() - 3);
  }

  var minStartDateLimitTS = (0, _date.dateToTimestamp)(minStartDateLimit);
  var multiuseStartDateTS = (0, _date.dateToTimestamp)(new Date(_constants.MULTIUSE_START));
  var query = "dateFromTS>=" + minStartDateLimitTS + " OR dateFromTS=" + multiuseStartDateTS; // include listings which doesn't have a start date only if user searches with a start date in near future

  if (minStartDateLimit < new Date()) {
    var noStartDateTS = (0, _date.dateToTimestamp)(new Date(_date.NO_START));
    return "(" + query + " OR dateFromTS=" + noStartDateTS + ")";
  }

  return "(" + query + ")";
};

var dateFromFilter = function dateFromFilter(startDate, endDate) {
  var start;

  if (startDate && endDate) {
    start = isShortRangeRent(startDate, endDate) ? startDate : (0, _date.addDays)(startDate, _constants.DateFlexibility);
  } else if (startDate) {
    start = isShortRangeRent(getCurrentDateUtc(), startDate) ? startDate : (0, _date.addDays)(startDate, _constants.DateFlexibility);
  } else {
    start = normalizeStartDate();
  }

  var startDateTS = (0, _date.dateToTimestamp)(new Date(start));
  var noStartDateTS = (0, _date.dateToTimestamp)(new Date(_date.NO_START));
  var multiuseStartDateTS = (0, _date.dateToTimestamp)(new Date(_constants.MULTIUSE_START));
  return "(dateFromTS<=" + startDateTS + " OR dateFromTS=" + noStartDateTS + " OR dateFromTS=" + multiuseStartDateTS + ")";
};

var dateFromTSBuilder = function dateFromTSBuilder(_a, context) {
  var startDate = _a.startDate,
      endDate = _a.endDate,
      advertiserId = _a.advertiserId;

  if (!startDate && advertiserId || (context === null || context === void 0 ? void 0 : context.withNewDateFilter)) {
    return '';
  }

  var dateFrom = dateFromFilter(startDate, endDate);
  var gapMinimize = gapMinimizeFilter(startDate, endDate);
  return [dateFrom, gapMinimize].filter(Boolean).join(' AND ');
};

var _default = dateFromTSBuilder;
exports["default"] = _default;